import { useGetPortfolioHistoricalReturnsByVolatilityQuery } from "../../../services/valuations";

const usePortfolioHistoricalReturnsByVolatility = (masterAccountId) => {
    const { data, error, isError, isLoading, isFetching, isUninitialized, refetch } = useGetPortfolioHistoricalReturnsByVolatilityQuery({ masterAccountId }/*, { refetchOnMountOrArgChange: true }*/);

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        reload : refetch
    };

};

export default usePortfolioHistoricalReturnsByVolatility;